import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';

import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { FetchDetailsForPincode as FETCH_DETAILS_FOR_PINCODE } from 'Components/Api/UsersApi';
import { FetchDetailsForPincode } from 'Pages/InnerPages/Users/FetchDetailsForPincode';
import Box from '@material-ui/core/Box';
import { ActivationInsert as ACTIVATION_TRANSECATION } from 'Components/Api/PrepiadActivationAPI';
import { SelectActivation as SELECT_ACTIVATION } from 'Components/Api/PrepiadActivationAPI';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import {
    Container,
    Grid,
    Paper,
    MenuItem,
    ListItemIcon,
    CircularProgress,
    Button
} from '@material-ui/core';
import {
    PREPAID_RECHARGE_CODE,
    PREPAID_ACTIVATION_CODE
} from 'Components/Helper/Messages';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID,
    MESSAGE_CLOSE_AFTER
} from 'Components/Helper/Messages';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import HOCLoader from 'Components/Loader/HOCLoader';
import ReactTable from 'Components/ReactTable/ReactTable';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import OfferIcon from 'Components/SvgButtons/OfferIcon';

const CustomContainer = HOCLoader(Container);

export const PrepaidActivation = () => {
    const formRef = useRef();
    const [serviceCode, setserviceCode] = useState(PREPAID_ACTIVATION_CODE);
    const [itemList, setItemList] = useState([]);
    const classes = commonStyle();
    const [Operator, setOperator] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [mainColumns, setMainColumns] = useState([]);
    const [isPincodeCheck, setPincodeCheck] = useState(false);
    const ActivationTypeList = [
        'NewConnection',
        'MNP',
        'PostPaid',
        'BroadBand'
    ];
    const [pincodeDetails, setPincodeDetails] = useState({
        CityName: '',
        State: '',
        District: '',
        Circle: '',
        Division: ''
    });
    const ActivationTypeItems = ActivationTypeList.map((item) => {
        return (
            <MenuItem key={item} value={item}>
                {item}
            </MenuItem>
        );
    });

    const [formObj, setFormObj] = useState({
        ServiceID: serviceCode,
        OperatorID: '0',
        AlternateNumber: '',
        ActivationType: '0',
        Name: '',
        Pincode: '',
        Address: ''
    });

    const validationSchema = Yup.object({
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator'),

        ActivationType: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'activation type')
            .required(PLEASE_SELECT_VALID + 'activation type'),

        AlternateNumber: Yup.number().required(PLEASE_PROVIDE_VALID + 'number'),

        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'Name'),

        Address: Yup.string().required(PLEASE_PROVIDE_VALID + 'Address'),

        Pincode: Yup.string()
            .length(6, 'Must be 6 digit')
            .required(PLEASE_PROVIDE_VALID + 'Pincode')
    });
    const submitHandle = async (values, { resetForm }) => {
        if (loadingOpen) return;

        let op = Operator.filter((o) => o.OperatorID === values.OperatorID);

        values.OperatorName = op[0].OperatorName;
        values.OperatorImagePath = op[0].Path;

        setIsAlertOpen(true);
        setConfirmAlertRequest(values);
    };

    const Recharge = async (values) => {
        setLoadingOpen(true);
        var request = JSON.stringify(values);

        setIsError(false);

        var response = await ACTIVATION_TRANSECATION(request);
        setLoadingOpen(false);
        setResponseMessage(response.data);
        setIsError(true);

        setSeverity('success');
        if (!response.status) {
            setSeverity('error');
            return;
        }
        setFormObj({
            OperatorID: '',
            AlternateNumber: '',
            ActivationType: ''
        });
        setTimeout(() => {
            selectData();
        }, MESSAGE_CLOSE_AFTER);
    };

    const selectData = async () => {
        const response = await SELECT_ACTIVATION();
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        var data = JSON.parse(response.data);
        setItemList(data);
    };

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    const pincodeValidation = Yup.object({
        Pincode: Yup.string().required(PLEASE_PROVIDE_VALID + 'Pincode')
    });

    const FetchDetails = async (values) => {
        var request = {
            Pincode: values.Pincode
        };

        let errorValidation = false;

        await pincodeValidation.validate(values).catch(function (err) {
            errorValidation = true;
        });

        if (errorValidation === true) {
            return;
        }

        var requestObj = JSON.stringify(request);

        setLoadingOpen(true);

        setIsError(false);

        var response = await FETCH_DETAILS_FOR_PINCODE(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setLoadingOpen(false);
        setIsError(true);
        setSeverity('success');

        setFormObj({
            ...formObj,
            Pincode: values.Pincode
        });

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);

        setPincodeDetails({
            ...pincodeDetails,
            CityName: data.CityName,
            State: data.State,
            District: data.District,
            Circle: data.Circle,
            Division: data.Division
        });

        setPincodeCheck(true);
    };

    useEffect(() => {
        createColumns();
        selectData();

        selectOperator(PREPAID_RECHARGE_CODE);
    }, [PREPAID_RECHARGE_CODE]);

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'PrepaidActivationID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'Date'
        });

        columns.push({
            label: 'User',
            name: 'UserName'
        });

        columns.push({
            label: 'Operator',
            name: 'OperatorName'
        });
        columns.push({
            label: 'Activation Type',
            name: 'ActivationType'
        });
        columns.push({
            label: 'Alternate Number',
            name: 'AlternateNumber'
        });
        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Address',
            name: 'Address'
        });
        columns.push({
            label: 'Pincode',
            name: 'Pincode'
        });
        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });

        setMainColumns(columns);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submitHandle}
                resetForm={formObj}
            >
                {({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Prepaid Activation
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="Select Operator"
                                                name="OperatorID"
                                                title="Operator"
                                                size="small"
                                                //margin="dense"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Operator
                                                </MenuItem>
                                                {Operator.map((item) => (
                                                    <MenuItem
                                                        key={item.OperatorID}
                                                        value={item.OperatorID}
                                                    >
                                                        <ListItemIcon
                                                            style={{
                                                                verticalAlign:
                                                                    'middle'
                                                            }}
                                                        >
                                                            <img
                                                                src={item.Path}
                                                                height={30}
                                                                width={30}
                                                                alt={
                                                                    item.OperatorName
                                                                }
                                                            />
                                                        </ListItemIcon>
                                                        {item.OperatorName}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="Select Activation Type"
                                                name="ActivationType"
                                                title="Select Activation Type"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Activation Type
                                                </MenuItem>
                                                {ActivationTypeItems}
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Alternate Number"
                                                name="AlternateNumber"
                                                icon="mobile"
                                                placeholder="Alternate Number"
                                                title="Alternate Number"
                                                length="10"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Name"
                                                name="Name"
                                                placeholder="Name"
                                                title="Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Address"
                                                name="Address"
                                                placeholder="Address"
                                                title="Address"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Pincode"
                                                name="Pincode"
                                                length={6}
                                                placeholder="Pincode"
                                                title="Pincode"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                variant="contained"
                                                color="primary"
                                                title="Search"
                                                endIcon={<SearchIcon />}
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                onClick={() => {
                                                    FetchDetails(values);
                                                }}
                                                style={{ marginLeft: '10px' }}
                                            ></PrimaryButton>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Request"
                                                endIcon={<OfferIcon />}
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loadingOpen}
                                            >
                                                Request
                                            </PrimaryButton>
                                            {loadingOpen && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <SecondaryButton
                                                type="reset"
                                                title="Reset"
                                                endIcon={<ResetIcon />}
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </SecondaryButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div
                                        className={classes.SubmitWrapper}
                                    ></div>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            <ReactTable data={itemList} columns={mainColumns} />
            {isPincodeCheck ? (
                <FetchDetailsForPincode
                    isOpen={isPincodeCheck}
                    request={pincodeDetails}
                    title="Verify Pincode"
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}
            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="Activation"
                    message="Are you sure to do activation?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Recharge(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            {isPincodeCheck ? (
                <FetchDetailsForPincode
                    isOpen={isPincodeCheck}
                    request={pincodeDetails}
                    title="Verify Pincode"
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
